//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CardexForm",
  props: ["value"],
  components: {},
  mounted: () => {},
  data: () => ({}),
  methods: {
    updateData() {
      this.$emit("value", this.value);
    },
  },
};
